import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useInstitutions } from './Institutions';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState([]);

  const handleChange = (event) => {
    setEntries({ ...entries, [event.target.name]: event.target.value });
  };

  return {
    entries,
    handleChange,
  };
}

export function PersonalizeInstitution(props) {
  const { institutions } = useInstitutions();
  const { entries, handleChange } = useForm();
  const classes = useStyles();
  const logoRef = useRef();
  const logoImg = useRef();
  const navigate = useNavigate();

  const handlePersonalize = async () => {
    const { institution, ...personalization } = entries;
    const formData = new FormData();
    formData.append('logo', personalization?.logo);
    formData.append('facebook', personalization?.facebook);
    formData.append('instagram', personalization?.instagram);
    formData.append('twitter', personalization?.twitter);
    formData.append('website', personalization?.website);

    const response = await fetch(
      `https://api.edicionesmilenio.com/api/institutions/personalize/${institution}`,
      {
        method: 'PUT',
        body: formData,
      }
    );

    if (response.status === 200) {
      navigate('/admin/institutions');
    } else {
      window.alert('Error al personalizar la institución, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado usuario, desde esta sección podrás personalizar la institución
        educativa, recuerda que este proceso debe contar con la autorización de
        la gerencia general de Ediciones Milenio, para este proceso, basta con
        seleccionar la institución, agregar las URL de las redes sociales y el
        logo en formato PNG sin fondo.
      </p>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution-label">
          Seleccione una institución
        </InputLabel>
        <Select
          labelId="institution-label"
          id="institution"
          name="institution"
          value={entries?.institution}
          onChange={handleChange}
          label="Seleccione una institución"
        >
          <MenuItem value="" disabled>
            <em>Ninguno</em>
          </MenuItem>
          {institutions.map((institution) => (
            <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Website"
        variant="outlined"
        name="website"
        value={entries?.website}
        onChange={handleChange}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Facebook"
        variant="outlined"
        name="facebook"
        value={entries?.facebook}
        onChange={handleChange}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Twitter"
        variant="outlined"
        name="twitter"
        value={entries?.twitter}
        onChange={handleChange}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Instagram"
        variant="outlined"
        name="instagram"
        value={entries?.instagram}
        onChange={handleChange}
      />
      <div
        className={classes.input}
        style={{
          width: '50%',
          background: '#eee',
          height: '50px',
          display: 'flex',
          justifyContent: 'center',
          cursor: 'pointer',
          borderRadius: '5px',
        }}
        onClick={() => logoRef.current.click()}
      >
        <input
          ref={logoRef}
          type="file"
          name="logo"
          style={{ display: 'none' }}
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            handleChange({
              target: {
                name: 'logo',
                value: file,
              },
            });
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
              logoImg.current.src = reader?.result;
            };
          }}
        ></input>
        {entries?.logo ? (
          <>
            <img
              style={{ height: '70%', marginRight: '10px' }}
              ref={logoImg}
              src={
                typeof entries?.logo === 'string'
                  ? 'https://api.edicionesmilenio.com' + entries?.logo
                  : URL.createObjectURL(entries?.logo)
              }
              alt="Logo"
            />
            {entries?.logo?.name}
          </>
        ) : (
          <span>Seleccione un logo para la institución</span>
        )}
      </div>
      <Button
        className={classes.input}
        variant="contained"
        color="primary"
        onClick={handlePersonalize}
      >
        Personalizar
      </Button>
    </div>
  );
}
